export default __webpack_public_path__ + "static/media/loss-setup-step3.cba974bb.gif";